import GetGreenroomInvitationsForMeeting from '@/connection/greenroom/get-greenroom-invitations-for-meeting';
import PostToGreenroomSocket from '@/connection/greenroom/post-to-greenroom-socket';
import { GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';

const syncGreenroomInvites = async ({ meetingId }: { meetingId: number }) => {
  try {
    // fetch latest invites to avoid accidentally sending stale invites
    const latestInvitations = await GetGreenroomInvitationsForMeeting({
      meeting: meetingId,
    });
    if (latestInvitations) {
      PostToGreenroomSocket<GreenroomInviteUserResponse[]>({
        channel: `meeting-${meetingId}`,
        type: 'invites-update',
        message: latestInvitations,
      });
    }
  } catch (error) {
    // don't really need to alert user since this is just a socket real time update and nothing data driven
    console.error(error);
  }
};

export default syncGreenroomInvites;
